import React, { useEffect, useRef, useState, useContext } from "react";
import { 
    Form, 
    Select, 
    Input,
} from "antd";
import { EditableContext } from "./editableFormRow";
import { formatValueOnChange } from 'utils/helper';

import { fetchUnitsListAPI } from 'services/shared/fetchLovList';

const {Option} = Select;
const { TextArea } = Input;

export const EditableCell = ({
	title,
	editable,
	children,
	dataIndex,
	record,
	handleSave,
	...restProps
}) => {
	const [editing, setEditing] = useState(false);
	const inputRef = useRef(null);
	const form = useContext(EditableContext);
	const [ loading, setLoading ] = useState(true);
	const [unitsList, setUnitsList] = useState([]);

	
	async function getLOVList(){
		try{
			const getUnit = await fetchUnitsListAPI();

			setUnitsList(getUnit);
		}catch(error){
			console.log("error", error);
		}

		if(unitsList){
			setLoading(false);
		};
	};

	useEffect( ()=> {
        function fetchData() {
            getLOVList();
        }
        fetchData();

    }, []);

	//get status list
    const unitsOptions = unitsList.map((item, index) => {
        return(
            <Option key={index} value={item.unit_name}>{item.unit_name}</Option>
        ); 
    });

	useEffect(() => {
		if (editing && (dataIndex !== 'unit_name') ) {
			if(dataIndex === 'line_description'){
				inputRef.current.focus();
			}else{
				inputRef.current.focus();
				inputRef.current.select();
			}
		}
	}, [editing, dataIndex]);

	const toggleEdit = () => {
		setEditing(!editing);
		form.setFieldsValue({
			[dataIndex]: record[dataIndex],
		});
	};

	const save = async () => {
		try {
			const values = await form.validateFields();
			toggleEdit();
			handleSave({ ...record, ...values }, values);
		} catch (errInfo) {
			console.log('Save failed:', errInfo);
		}
	};
	
	const handleQntOnChange = (e) => {
        const qnt = e.target.value === '' ? 0 : e.target.value;

        const formatedValue = formatValueOnChange(qnt, 'numeric');
        form.setFieldsValue({quantity: formatedValue});
    };

	const handleUntPriceOnChange = (e) => {
        const untPrice = e.target.value === '' ? 0.00 : e.target.value;

        const formatedValue = formatValueOnChange(untPrice, 'withnegative');
        form.setFieldsValue({unit_price: formatedValue});
    };

	const handleAmtOnChange = (e) => {
        const amt = e.target.value === '' ? 0.00 : e.target.value;

        const formatedValue = formatValueOnChange(amt, 'withnegative');
        form.setFieldsValue({amount: formatedValue});
    };

	const handleLineUnitNameOnChange = (e) => {
		// const unitNameValue = e.target.value;
		form.setFieldsValue({unit_name: e});
	}

	let childNode = children;

	if (editable) {
		if(dataIndex === 'quantity'){
			childNode = editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
					// rules={[ { required: true, message: `${title} is required.`, }, ]}
				>
					<Input 
						ref={inputRef} 
						onPressEnter={save} 
						onBlur={save} 
						placeholder="0"
						onChange={handleQntOnChange}
					/>
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
					}}
					onClick={toggleEdit}
					onFocus={toggleEdit}
				>
					{children}
				</div>
			);
		}
        else if(dataIndex === 'unit_name'){
			childNode = editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
					// rules={[ { required: true, message: `${title} is required.`, }, ]}
				>
                    <Select 
						ref={inputRef}
						onChange={save}
						onBlur={save}
                        placeholder="UNIT"
                        defaultOpen={true}
						loading={loading}
						onSelect={handleLineUnitNameOnChange}
                    >
                        {unitsOptions}
                    </Select>
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
					}}
					onClick={toggleEdit}
					onFocus={toggleEdit}
				>
					{children}
				</div>
			);
        }
        else if(dataIndex === 'unit_price'){
			childNode = editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
					// rules={[
					// 	{
					// 		required: true,
					// 		message: `${title} is required.`,
					// 	},
					// ]}
				>
					<Input
                        ref={inputRef} 
                        onPressEnter={save} 
                        onBlur={save}
                        placeholder="0.00"
						onChange={handleUntPriceOnChange}
                    />
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
					}}
					onClick={toggleEdit}
					onFocus={toggleEdit}
				>
					{children}
				</div>
			);
        }
        else if(dataIndex === 'amount'){
			childNode = editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
					//rules={[
					//	{
					//		required: true,
					//		message: `${title} is required.`,
					//	},
					//]}
				>
					<Input
                        ref={inputRef} 
                        onPressEnter={save} 
                        onBlur={save}
                        placeholder="0.00"
						onChange={handleAmtOnChange}
					/>
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap"
					style={{
						paddingRight: 24,
					}}
					onClick={toggleEdit}
					onFocus={toggleEdit}
				>
					{children}
				</div>
			);
		}
        else if(dataIndex === 'line_description'){
			childNode = editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
				>
					<TextArea ref={inputRef} maxLength={750} onBlur={save} className="inv-input-uppercase" />
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap inv-input-uppercase"
					style={{
						paddingRight: 24,
						wordBreak: 'break-word',
					}}
					onClick={toggleEdit}
					onFocus={toggleEdit}
				>
					{children}
				</div>
			);
		}
        else{
			childNode = editing ? (
				<Form.Item
					style={{
						margin: 0,
					}}
					name={dataIndex}
					// rules={[ { required: true, message: `${title} is required.`, }, ]}
				>
					<Input ref={inputRef} maxLength={100} onPressEnter={save} onBlur={save} className="inv-input-uppercase" />
				</Form.Item>
			) : (
				<div
					className="editable-cell-value-wrap inv-input-uppercase"
					style={{
						paddingRight: 24,
						wordBreak: 'break-word',
					}}
					onClick={toggleEdit}
					onFocus={toggleEdit}
				>
					{children}
				</div>
			);
		}
	}

	return <td {...restProps}>{childNode}</td>;
};